<div class="container" style="max-width:1000px;margin:24px auto;font-family:system-ui,Arial,sans-serif;">
  <header style="margin-bottom:16px;display:flex;gap:12px;align-items:end;flex-wrap:wrap;">
    <h2 style="margin:0;">
      {{ overlay?.meta?.name || (drugKey || 'İlaç') }}
      <small *ngIf="overlay?.meta?.atc">({{ overlay.meta.atc }})</small>
    </h2>
    <div style="color:#666;font-size:12px" *ngIf="overlay?.meta?.version">v{{ overlay.meta.version }}</div>
  </header>

  <!-- Drug & Indication -->
  <section style="border:1px solid #ddd;border-radius:10px;padding:12px;margin-bottom:12px;display:grid;gap:8px;grid-template-columns:1fr 1fr;">
    <div>
      <label style="font-weight:600;">İlaç</label>
      <ng-container *ngIf="drugs.length; else manualKey">
        <select [(ngModel)]="drugKey" (change)="onDrugChange()">
          <option *ngFor="let d of drugs" [value]="d.key">{{ d.label || d.key }}</option>
        </select>
      </ng-container>
      <ng-template #manualKey>
        <div style="display:flex; gap:8px; align-items:center;">
          <input placeholder="overlay key (örn: pembrolizumab)" [(ngModel)]="drugKey" />
          <button type="button" (click)="onDrugChange()">Yükle</button>
        </div>
        <small style="color:#666;">Manifest yoksa anahtar yazarak yükleyebilirsin (assets/sut/overlays/&lt;key&gt;.overlay.json).</small>
      </ng-template>
    </div>

    <div>
      <label style="font-weight:600;">Endikasyon</label>
      <select [(ngModel)]="indicationCode" (change)="onIndicationChange(indicationCode)">
        <option *ngFor="let ind of overlay?.indications" [value]="ind.code">{{ ind.label }}</option>
      </select>
    </div>
  </section>

  <!-- Quick Presets -->
  <section style="border:1px solid #ddd;border-radius:10px;padding:12px;margin-bottom:12px;">
    <div style="display:flex;gap:8px;flex-wrap:wrap;align-items:center;">
      <label style="font-weight:600;margin-right:8px;">Hızlı Senaryo</label>
      <ng-container *ngIf="quickPresets.length; else noPreset">
        <button *ngFor="let p of quickPresets" type="button" (click)="applyPreset(p)">{{ p.label }}</button>
      </ng-container>
      <ng-template #noPreset>
        <span style="color:#888;">Bu form için preset bulunamadı (opsiyonel).</span>
      </ng-template>
      <span style="flex:1;"></span>
      <button type="button" (click)="resetModel()">Sıfırla</button>
    </div>
  </section>

  <!-- Claim + ICD quick -->
  <section style="display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-bottom:12px;">
    <div style="border:1px solid #ddd;border-radius:10px;padding:12px;">
      <h3 style="margin-top:0;">Reçete Bilgisi</h3>
      <div style="display:grid;gap:8px;">
        <label>Ayar</label>
        <select [(ngModel)]="Claim.Setting" (change)="evaluate()">
          <option value="outpatient">Ayaktan</option>
          <option value="daycare">Gündüz Tedavi</option>
          <option value="inpatient">Yatan</option>
        </select>

        <label><input type="checkbox" [(ngModel)]="Claim.IsFirstPrescription" (change)="evaluate()" /> İlk Reçete</label>

        <label>Karşılama Gün Sayısı</label>
        <input type="number" [(ngModel)]="Claim.SupplyDays" (input)="evaluate()" />

        <!-- ICD quick list -->
        <div *ngIf="icdPresets.length" style="display:grid;gap:6px;">
          <label>ICD-10 Hızlı Seçim</label>
          <select [(ngModel)]="selectedIcd" (change)="applyIcd(selectedIcd)">
            <option [ngValue]="''">—</option>
            <option *ngFor="let icd of icdPresets" [ngValue]="icd.code">{{ icd.code }} — {{ icd.label }}</option>
          </select>
          <div style="font-size:12px;color:#555;">Seçili ICD-10: <b>{{ Claim.ICD10 || '—' }}</b></div>
        </div>

        <label><input type="checkbox" [(ngModel)]="Documents.has_health_report" (change)="evaluate()" /> Sağlık Raporu Var</label>
      </div>
    </div>

    <!-- Dynamic Patient/Clinic Panel -->
    <section *ngIf="patientPanel?.fields?.length"
             style="border:1px solid #ddd;border-radius:10px;padding:12px;">
      <h3 style="margin-top:0;">{{ patientPanel?.title || 'Hasta / Klinik' }}</h3>
      <div style="display:grid;gap:8px;">
        <ng-container *ngFor="let f of patientPanel.fields; index as i">
          <div [hidden]="!visibleField(f)" style="display:grid;gap:6px;">
            <label *ngIf="f.label">{{ f.label }}</label>

            <input *ngIf="f.type==='text'" type="text"
                   [(ngModel)]="model[f.key]" (input)="evaluate()" />

            <input *ngIf="f.type==='number'" type="number"
                   [min]="f.validators?.min" [max]="f.validators?.max"
                   [(ngModel)]="model[f.key]" (input)="evaluate()" />

            <label *ngIf="f.type==='checkbox'">
              <input type="checkbox" [(ngModel)]="model[f.key]" (change)="evaluate()" />
              <span *ngIf="!f.label">{{ f.key }}</span>
            </label>

            <select *ngIf="f.type==='select'" [(ngModel)]="model[f.key]" (change)="evaluate()">
              <option *ngFor="let o of f.options" [value]="o.value ?? o">{{ o.label ?? o }}</option>
            </select>

            <small *ngIf="f.help" style="color:#666;">{{ f.help }}</small>
          </div>
        </ng-container>
      </div>
    </section>
  </section>

  <!-- Dynamic form steps -->
  <section *ngIf="form" style="display:grid;gap:12px;margin-bottom:12px;">
    <div *ngFor="let step of form.steps"
         style="border:1px solid #ddd;border-radius:10px;padding:12px;"
         [hidden]="!visibleStep(step)">
      <h3 style="margin-top:0;">{{ step.title }}</h3>

      <div style="display:grid;gap:10px;">
        <ng-container *ngFor="let f of step.fields">
          <div [hidden]="!visibleField(f)" style="display:grid;gap:6px;">
            <label *ngIf="f.label">{{ f.label }}</label>

            <input *ngIf="f.type==='text'" type="text"
                   [(ngModel)]="model[f.key]" (input)="evaluate()" />

            <input *ngIf="f.type==='number'" type="number"
                   [min]="f.validators?.min" [max]="f.validators?.max"
                   [(ngModel)]="model[f.key]" (input)="evaluate()" />

            <label *ngIf="f.type==='checkbox'">
              <input type="checkbox" [(ngModel)]="model[f.key]" (change)="evaluate()" />
              <span *ngIf="!f.label">{{ f.key }}</span>
            </label>

            <select *ngIf="f.type==='select'" [(ngModel)]="model[f.key]" (change)="evaluate()">
              <option *ngFor="let o of f.options" [value]="o.value ?? o">{{ o.label ?? o }}</option>
            </select>

            <small *ngIf="f.help" style="color:#666;">{{ f.help }}</small>
          </div>
        </ng-container>
      </div>
    </div>
  </section>

  <!-- Result + Hints -->
  <section [style.background]="outcomeText==='COVERED' ? '#e8f5e9' : '#ffebee'"
           [style.border]="outcomeText==='COVERED' ? '2px solid #2e7d32' : '2px solid #c62828'"
           style="padding:12px;border-radius:10px;">
    <b>Sonuç:</b> {{ outcomeText || '—' }}
    <ul *ngIf="reasons?.length" style="margin:8px 0 0 18px;">
      <li *ngFor="let r of reasons">{{ r }}</li>
    </ul>

    <div *ngIf="hints.length"
         style="margin-top:8px;padding:8px;border-radius:8px;background:#fff3e0;border:1px dashed #ffb300;">
      <b>Uyarılar:</b>
      <ul style="margin:6px 0 0 18px;">
        <li *ngFor="let h of hints"><i>{{ h }}</i></li>
      </ul>
    </div>
  </section>
</div>
